<template>
    <div>
        <TheHeader class="mob-header" />
        <template>
            <BaseTitle 
                :infor="json" 
            />

            <div class="method-resources">
                <BaseTitleCenter 
                    class="method-resources-title" 
                    :title="json.session.title" 
                />
                <p 
                    class="method-resources-text" 
                    v-html="json.session.text"
                ></p>
                <img
                    class="method-resources-image" 
                    :src="json.session.image"
                >
            </div>

            <div class="method-list">
                <BaseTitleCenter 
                    class="method-resources-title" 
                    :title="json.principle.title" 
                /> 
                <dl 
                    class="method-list-dl" 
                    v-for="v in json.principle.list" 
                    :key="v.id"
                >
                    <dt class="method-list-dt"><span class="method-list-dt-span"><b class="method-list-order">{{v.id}}</b>. {{v.title}}</span></dt>
                    <dd class="method-list-dd">{{v.text}}</dd>
                </dl>
            </div>

            <div class="method-process">
                <BaseTitleCenter 
                    class="method-process-title" 
                    :title="json.process.title" 
                />
                <div class="method-process-image" :style="{backgroundImage: 'url(' + json.process.image + ')'}">
                    <span class="L">洞察+分析</span>
                    <span class="R">探索+创意</span>
                    <span class="L">评估+实施</span>
                    <span class="R">原型+方案 </span>
                </div>
            </div>

        </template>
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>
<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseTitleCenter from '@/components/module/BaseTitleCenter'

    export default {
        name: 'MobMethod',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseTitleCenter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@rem: 37.5rem;
.method-resources {
    width: 300/@rem;
    margin: 0 auto;
    padding: 25/@rem 0 30/@rem;
    text-align: center;
    .method-resources-title {
        padding: 0 0  20/@rem;
    }
    .method-resources-text {
        margin: 0 auto 20/@rem;
        font-size: 12/@rem;
        line-height: 1.5em;
        text-align: center;
        color: #666;
    }
    .method-resources-image {
        display: inline-block;
    }
}

.method-list {
    padding-top: 30/@rem;
    padding-bottom: 1px;
    background: #F0F4F6;
    font-size: 14/@rem;
    color: #666;
    text-align: center;
    .method-resources-title {
        width: 300/@rem;
        margin: 0 auto;    
        padding-bottom: 30/@rem;
    }
    .method-list-dl {
        width: 300/@rem;
        margin: 0 auto;           
        .method-list-dt {
            position: relative;
            display: inline-block;
            padding: 0 5px 5px;
            margin-bottom: 12/@rem;
            &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: 5/@rem;
                left: 0;
                height: 6/@rem;
                width: 100%;
                background: #FF764E;
            }
            .method-list-dt-span {
                position: relative;
                z-index: 10;
                 font-weight: bold;
                 color: #333;
                .method-list-order {
                    font-size: 20/@rem;
                    color: #333;
                }                
            }
        }
        .method-list-dd {
            font-size: 14/@rem;
            margin-bottom: 35/@rem;
        }
    }
}

.method-process {
    width: 300/@rem;
    margin: 0 auto;    
    padding: 30/@rem 0 30/@rem;
    .method-process-image {
        transform: scale(.8);
        width: 100%;
        height: 300/@rem;
        background-size: 100% 100%;
        span {
            display: block;
            width: 145/@rem;
            height: 145/@rem;
            margin-bottom: 10/@rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18/@rem;
            // font-weight: bold;
        }
    }
}


</style>
